import React, { forwardRef } from 'react'
import { v4 as uuid } from 'uuid'
import { TextInputV2 } from '@manychat/manyui'

import { ChannelForRn } from 'common/core/constants/ChannelType'
import { ReasonTypes } from 'common/oneTimeNotify/constants/notifyReasonConstants'
import { getReasonTypeLabel } from 'common/oneTimeNotify/utils'

import cm from './InputWithTopicType.module.css'

const InputWithTopicType: React.ForwardRefRenderFunction<
  HTMLInputElement,
  { reasonType?: ReasonTypes; channel?: ChannelForRn; value?: string } & Omit<
    React.ComponentPropsWithoutRef<typeof TextInputV2>,
    'value'
  >
> = ({ reasonType, channel, ...inputProps }, ref) => {
  const inputId = uuid()

  const props = {
    ...inputProps,
    value: `${inputProps.value} ${
      reasonType ? `(${getReasonTypeLabel(reasonType, channel)})` : ''
    }`,
  }

  return (
    <div className="p-relative">
      <TextInputV2
        inputRef={ref}
        id={inputId}
        {...props}
        className={cm.croppedInput}
        ariaLabel="Reason Type"
      />
    </div>
  )
}

export const InputWithTopicTypeRef = forwardRef(InputWithTopicType)
